// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export function isInsideRefs(target, refs) {
    return refs.some((ref) => { var _a; return ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(target)) === true; });
}
export function isInsideNestedPopover(currentPopover, target) {
    if (currentPopover === null) {
        return false;
    }
    const container = currentPopover.parentElement;
    if (container === null) {
        return false;
    }
    const popovers = container.querySelectorAll(':scope > .popover');
    let afterCurrent = false;
    for (const popover of popovers) {
        if (popover === currentPopover) {
            afterCurrent = true;
            continue;
        }
        if (afterCurrent && popover.contains(target) === true) {
            return true;
        }
    }
    return false;
}
